import { withRouter } from 'react-router-dom';
import { Link, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({

    SpanStyle: {
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "24px",
        textAlign: "center",
        display: "grid"
        // "@media (min-width:1500px)": {
        //     marginLeft: "650px"
        // },
        // "@media screen and (min-width:800px) and (max-width:1500px)": {
        //     marginLeft: "280px"
        // }
    }
})

function Foot(props) {

    const classes = useStyles();

    return (
        <footer>
            <div className="version-show">
                {props.Country && props.Country === "HK" && props.Lang && props.Lang === "zh_cn" ?
                    <span className={classes.SpanStyle}>
                        <span>
                            版權 © 2008 – {props.year} – 華僑銀行 (香港) 有限公司 保留所有權利。
                        </span>
                        <span>
                            <Link color="inherit" href='https://www.ocbc.com.hk/webpages/zh-hk/html/disclaimer/disclaimer.html'> &nbsp;免責條款</Link> |
                            <Link color="inherit" href='https://www.ocbc.com.hk/webpages/zh-hk/html/disclaimer/privacy.html'> &nbsp;私隱政策及收集個人資料聲明</Link>
                        </span>
                    </span>
                    :
                    <span className={classes.SpanStyle}>
                        <span>
                            Copyright© 2008-{props.year}-OCBC Bank (Hong Kong) Limited. All Rights Reserved.
                        </span>
                        <span>
                            <Link color="inherit" href='https://www.ocbc.com.hk/webpages/en-us/html/disclaimer/disclaimer.html'> &nbsp;Disclaimer</Link> |
                            <Link color="inherit" href='https://www.ocbc.com.hk/webpages/en-us/html/disclaimer/privacy.html'> &nbsp;Privacy Policy & Personal Information Collection Statement</Link>
                        </span>
                    </span>
                }
            </div >
        </footer>
    );
}

export default withRouter(Foot);